exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button-mini[data-v-581b4cd3] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -webkit-column-gap: 8px;\n     -moz-column-gap: 8px;\n          column-gap: 8px;\n  border-radius: 10px;\n}\n", ""]);

// exports
